export default "__VITE_ASSET__Dg9m1Jc9__"